export const ASSIGN_DEVICE_MODAL_FORM = 'ASSIGN_DEVICE_MODAL_FORM'
